import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setLoading } from '../../../store/slices/UI';

export const initSupplier = {
  initVisible: false,

  isCloseVisible: true
};

const { initVisible } = initSupplier;

const useSupplier = () => {
  const [visible, setVisible] = useState(initVisible);
  const [isCloseVisible, setIsCloseVisible] = useState(initVisible);

  // Redux
  const dispatch = useDispatch();

  const showAddSupplier = useCallback(
    (isCloseVisible = true) => {
      dispatch(setLoading(false));
      setVisible(true);
      setIsCloseVisible(isCloseVisible);
    },
    [dispatch]
  );

  const hideAddSupplier = useCallback(() => {
    setVisible(false);
  }, []);

  return {
    visible: visible,
    showAddSupplier: showAddSupplier,
    hideAddSupplier: hideAddSupplier,
    isCloseVisible
  };
};

export default useSupplier;
